export default __webpack_public_path__ + "images/noItemCars.e2edec48.svg";